<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Productos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: 80px;width: auto;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text Productos
    v-flex(xs12 style='margin-top:5px;padding-left:20px;margin-bottom:5px')
      v-layout(wrap='' style='display: flex;align-items: center;')
        v-flex(xs12 style="margin-top: 5px;")
          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
            v-flex(xs4 sm4)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  a(@click='sinEst("c")')
                    v-card(style='width:300px;height:auto;border-radius:10px;padding: 20px;').elevation-3
                        span(style='display:flex;justify-content:center;font-size:20px') Total de Productos
                        h1(style='display:flex;justify-content:center') {{tot}}
            v-flex(xs4 sm4)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  a(@click='sinEst("Disponible")')
                    v-card(style='width:300px;height:auto;border-radius:10px;padding: 20px;').elevation-3
                        span(style='display:flex;justify-content:center;font-size:20px') Productos Disponibles
                        h1(style='display:flex;justify-content:center') {{disp}}
            v-flex(xs4 sm4)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  a(@click='sinEst("No disponible")')
                    v-card(style='width:300px;height:auto;border-radius:10px;padding: 20px;').elevation-3
                        span(style='display:flex;justify-content:center;font-size:20px') Productos No Disponibles
                        h1(style='display:flex;justify-content:center') {{nodisp}}
            v-flex(xs4 sm4 style='margin-top:15px')
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  a(@click='sinEst(null)')
                    v-card(style='width:300px;height:auto;border-radius:10px;padding: 20px;' ).elevation-3
                      span(style='display:flex;justify-content:center;font-size:20px') Productos Sin Estatus
                      h1(style='display:flex;justify-content:center') {{sines}}
            v-flex(xs4 sm4 style='margin-top:15px')
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  a(@click='sinImg()')
                    v-card(style='width:300px;height:auto;border-radius:10px;padding: 20px;' ).elevation-3
                      span(style='display:flex;justify-content:center;font-size:20px') Productos Sin Imagenes
                      h1(style='display:flex;justify-content:center') {{sinimg}}
        v-flex(xs12 style='padding-right: 20px;margin-top:10px;')
          v-layout(wrap='' style='display: flex;align-items: center;')
            v-flex(xs12 sm6)
              v-text-field(v-model='search5' label='Buscar producto...' append-icon='search')
    v-flex(xs12 style='margin-top:5px')
      template
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Productos
        v-data-table.elevation-1(:headers='headers', :items="productos", style="margin-top: 5px;", hide-actions, :pagination.sync="pagination")
          template(slot='items', slot-scope='props')
            td(v-if="props.item.co_art") {{ props.item.co_art }}
            td(v-else) {{ "- -" }}
            td(v-if="props.item.nombre") {{ props.item.nombre }}
            td(v-else) {{ "- -" }}
            td(v-if="props.item.precioToF") {{ props.item.precioToF }}
            td(v-else) {{ "- -" }}
            //- td(v-if="props.item.preciobsToF") {{ props.item.preciobsToF }}
            //- td(v-else) {{ "- -" }}
            td(v-if="props.item.existencia") {{ props.item.existencia }}
            td(v-else) {{ "- -" }}
            td(v-if="props.item.categoria && props.item.categoria._id") {{ props.item.categoria.nombre }}
            td(v-else) {{ "- -" }}
            td(v-if="props.item.estatus") {{ props.item.estatus }}
            td(v-else) {{ "- -" }}
            td.justify-start.layout.px-0
              v-btn.mx-0(icon, @click='editItem(props.item)', style='margin-top: -9px;')
                v-icon(color='teal') edit
              v-btn.mx-0(icon, @click='cambio(props.item)', style='margin-top: -9px;')
                v-icon(color='teal' v-if="props.item.destacado === false") star
                v-icon(color='red' v-if="props.item.destacado === true") star
        v-card
          v-flex(xs12)
            v-layout(wrap='')
              v-flex(xs6)
              v-flex(xs5 style='display: flex;justify-content: flex-end;align-items: center;')
                div(style='margin: 10px;')
                  span {{min}} a {{max}} elementos
                div(style='margin: 2px;')
                  v-btn.mx-0(id='prev' icon, @click='prev()', style='background: gainsboro;border-radius:50%;' hidden)
                    v-icon(color='black' style='font-size: 1.8rem;') arrow_left
                div(style='margin: 2px;' v-for='(item,index) in listado')
                  v-btn.mx-0(:id='"num"+item', @click='seleccion(item)' icon, style='background: gainsboro;border-radius:50%;')
                    span(style='font-weight: bold;color:black;') {{item}}
                div(style='margin: 2px;')
                  v-btn.mx-0(id='next' icon, @click='next()', style='background: gainsboro;border-radius:50%;')
                    v-icon(color='black' style='font-size: 1.8rem;') arrow_right
              v-flex(xs1)
              v-flex(xs11 style='display: flex;justify-content: flex-end;')
                v-flex#sll(xs2 style='display: flex;justify-content: flex-end;align-items: center;margin-right: 17px;')
                  v-select(id="paginas"
                  outline
                  @change='seleccion(selpag)'
                  :items="paginas"
                  v-model="selpag"
                  dense
                  required
                  label="Página:")

    v-dialog(v-model='dialog', persistent max-width='1000px')
      v-container(style='background-color:white !important;max-width: 1000px;')
        v-card-title.justify-center
            span.headline Usuario
        div(style="margin-top: 20px;")
            v-flex(xs12 sm12)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                    v-flex(xs8)
                      v-form(enctype="multipart/form-data")
                        span(style='font-size: 14px;font-weight: bold;') Nombre
                        v-text-field(outline='' dense v-model="form.nombre" disabled)

                        span(style='font-size: 14px;font-weight: bold;') Codigo artículo profit
                        v-text-field(outline='' dense v-model='form.co_art' disabled)

                        span(style='font-size: 14px;font-weight: bold;') Categoría
                        v-select(outline dense :items="categoria" v-model="form.categoria" disabled)

                        span(style='font-size: 14px;font-weight: bold;') Unidad
                        v-text-field(outline='' dense v-model="form.unidad" disabled)

                        span(style='font-size: 14px;font-weight: bold;') Existencia
                        v-text-field(outline='' dense type="number" v-model="form.existencia" disabled )

                        span(style='font-size: 14px;font-weight: bold;') Precio €
                        v-text-field(outline='' dense type="number" v-model="form.precioToF" disabled)

                        //- span(style='font-size: 14px;font-weight: bold;') Precio BS
                        //- v-text-field(outline='' dense type="number" v-model="form.preciobsToF" disabled)

                        span(style='font-size: 14px;font-weight: bold;') Estatus
                        v-switch(dense style='padding-top: 0px' color='success' v-model='switch2' :label="`${form.estatus}`" )

                        v-flex(xs12 style='padding:5px')
                          div(style='display:flex;justify-content:center')
                            a(:href='ruta + img2' target="_blank" v-if='img2 && !form.pdf.pdfUrl')
                              img(src='../assets/pdf.png', height='60', width='80')
                          div(style='display:flex;justify-content:center')
                            img(src='../assets/pdf.png', height='60', width='80'  v-if='form.pdf.pdfUrl')

                        v-flex(xs12) 
                          span(style='font-size: 14px;font-weight: bold;') Seleccionar PDF
                          v-text-field(outline dense @click='pickFile2', prepend-inner-icon='attach_file')
                          input(
                            type="file"
                            style="display: none"
                            ref="pdf"
                            accept="application/pdf"
                            @change="onFilePicked2")
        
                        v-flex(xs12 style='padding:5px')
                          v-layout(style='justify-content: center;')
                            v-flex(xs6 v-for='(item,i) in form.imagen' :key='i' style='padding: 10px;')
                              v-card(style='border-radius: 20px;border: 2px solid #d8d8d8;' v-if='item.imageName').elevation-3
                                v-card-text(style='display: flex;justify-content: center;height: auto;')
                                  div(style='position:absolute;margin-top: -18px;margin-right: -2px;width:100%;display:flex;justify-content:flex-end')
                                    v-btn(@click="indice(i, item.imageName)", color='error' style='border-radius: 20px;').btnnn X
                                  img(:src='item.imageUrl', v-if='item.imageUrl' style='width: 70%;height: auto;')
                              v-card(style='border-radius: 20px;border: 2px solid #d8d8d8;' v-if='item.url').elevation-3
                                v-card-text(style='display: flex;justify-content: center;height: auto;')
                                  div(style='position:absolute;margin-top: -18px;margin-right: -2px;width:100%;display:flex;justify-content:flex-end')
                                    v-btn(@click="indice(i, item.url)",color='error' style='border-radius: 20px;').btnnn X
                                  img(:src='ruta + item.url', v-if='item.url' style='width: 70%;height: auto;')
                        v-flex(xs12 style='text-align: -webkit-center;')
                        v-flex(xs12) 
                          span(style='font-size: 14px;font-weight: bold;') Seleccionar imagenes desde pc
                          v-text-field(outline dense @click='pickFile', prepend-inner-icon='attach_file' multiple)
                          input(
                            type="file"
                            style="display: none"
                            ref="image"
                            multiple
                            accept="image/*"
                            @change="onFilePicked")

                        div(style="display: flex;justify-content: center;")
                            v-btn(style="background:#0093dd;border-radius:10px;", @click.native='save' :disable='guard' v-if="loading === false") Guardar
                            v-progress-circular(indeterminate='', v-if="loading === true" style='border-radius: 10px;color: #0093dd;')
                            v-btn(style="background:black;;border-radius:10px;", v-if="loading === false" @click.native='close') Salir

    //===========================================================Modal Espera==============================================================================================
    v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
      v-container(style='max-width: 400px;background:#f1f2f1')
        div(style="margin-top: 20px;")
            v-flex(xs12 sm12)
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h4.black--text  Esperando Respuesta del Servidor.!!
                v-flex(xs12)
                    div(style='display: flex;justify-content: center;').text-xs-center
                      img(src='../assets/waiting.gif', with='200' ,height='150')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mProductos",
  components: {},
  data: () => ({
    menu: false,
    estatussel: "c",
    loading: false,
    imgsel: false,
    seleccionado: null,
    listado: [],
    guard: false,
    dialog4: false,
    paginas: [],
    selpag: "",
    switch2: false,
    multiple: true,
    index: null,
    search5: "",
    actual: 0,
    pagination: {
      rowsPerPage: 20
    },
    form: {
      nombre: "",
      precio: 0,
      preciobs: 0,
      precioToF: 0,
      preciobsToF: 0,
      co_art: "",
      unidad: "",
      existencia: 0,
      categoria: "",
      imagen: [],
      pdf: {
        imageName: "",
        imageFile: "",
        imageUrl: ""
      },
      estatus: ""
    },
    defaultForm: {
      nombre: "",
      precio: 0,
      preciobs: 0,
      precioToF: 0,
      preciobsToF: 0,
      co_art: "",
      unidad: "",
      existencia: 0,
      categoria: "",
      imagen: [],
      pdf: {
        pdfName: "",
        pdfFile: "",
        pdfUrl: ""
      },
      estatus: ""
    },
    dialog: false,
    editedIndex: -1,
    editedIndex2: -1,
    categoria: [],
    ruta: server + ":" + port,
    productos: [],
    headers: [
      { text: "Código", value: "co_art" },
      { text: "Nombre", value: "nombre" },
      { text: "€", sortable: false, value: "precioToF" },
      // { text: "BSS", sortable: false, value: "preciobsToF" },
      { text: "Existencia", sortable: false, value: "existencia" },
      { text: "Categoría", value: "categoria" },
      { text: "Estatus", sortable: false, value: "estatus" },
      { text: "Acción", sortable: false, value: "action" }
    ],
    files: [],
    files2: [],
    sw2: "",
    min: 0,
    max: 0,
    disp: 0,
    tot: 0,
    nodisp: 0,
    sines: 0,
    sinimg: 0,
    cre: "",
    mod: "",
    elm: "",
    img2: ""
  }),
  watch: {
    search5(data) {
      if (data) {
        this.busqinit(data);
      }
    },
    switch2(val) {
      if (val === true) {
        this.form.estatus = "Disponible";
        this.sw2 = "Disponible";
      } else {
        this.form.estatus = "No disponible";
        this.sw2 = "No disponible";
      }
    }
  },
  computed: {},
  created() {
    this.initialize();
    this.verificacion();
  },
  methods: {
    initialize() {
      this.img2 = "";
      this.estatussel = "c";
      this.imgsel = false;
      this.form.imagen.imageName = "";
      this.form.imagen.imageFile = "";
      this.form.imagen.imageUrl = "";
      this.form.pdf.pdfName = "";
      this.form.pdf.pdfFile = "";
      this.form.pdf.pdfUrl = "";
      this.editedIndex = -1;
      this.dialog4 = true;
      Api.get("productos/sinseleccion?estatus=c&img=" + this.imgsel)
        .then((res) => {
          this.productos = [];
          this.productos = res.data.resultado;
          if (this.productos.length > 0) {
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);
              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
          }
          this.tot = res.data.cantidad;
          this.disp = res.data.cantdi;
          this.nodisp = res.data.cantno;
          this.sines = res.data.cantnull;
          this.sinimg = res.data.cantimg;
          this.max = this.productos.length;
          if (this.max === 0) {
            this.min = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.min = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.min = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            this.$nextTick(() => {
              if (this.listado.length > 0 && document.getElementById("num1")) {
                document
                  .getElementById("num1")
                  .setAttribute(
                    "style",
                    "background-color:#adadad;border-radius:50%;"
                  );
              }
            });
            this.selpag = 1;
            this.actual = 1;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
      Api.get("categorias").then((res) => {
        this.categoria = [];
        res.data.map((cat) => {
          this.categoria.push({ value: cat._id, text: cat.nombre });
        });
      });
    },
    catSelec(item, id) {
      let array = {
        _id: item._id,
        categoria: id,
      };
      Api.put("productos/cat", array)
        .then((res) => {
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          for (let i = 0; i < this.productos.length; i++) {
            if (this.productos[i]._id === res.data._id) {
              this.$set(this.productos, i, res.data);
              res.data.preciobsToF = parseFloat(res.data.preciobs);
              res.data.precioToF = parseFloat(res.data.precio);
              res.data.preciobsToF = res.data.preciobsToF.toFixed(2)
              res.data.precioToF = res.data.precioToF.toFixed(2)
            }
          }
        })
        .catch((error) => {
          if (error.res) {
            this.$swal({
              icon: "error",
              title: "Error al modificar",
              text: "Error encontrado, verifique los datos o llame al administrador.",
            });
          } else {
            console.log("Error", error.message);
          }
        });
    },
    cambio (item) {
      if (item.destacado === false) {
        let array = {
          _id: item._id,
          destacado: true,
        };
        Api.put("productos/destacado", array)
          .then((res) => {
            this.$swal.fire(
              "Felicidades.!",
              "Añadido a nuevos productos",
              "success"
            );
            for (let i = 0; i < this.productos.length; i++) {
              if (this.productos[i]._id === res.data._id) {
                this.$set(this.productos, i, res.data);
                res.data.preciobsToF = parseFloat(res.data.preciobs);
                res.data.precioToF = parseFloat(res.data.precio);
                res.data.preciobsToF = res.data.preciobsToF.toFixed(2)
                res.data.precioToF = res.data.precioToF.toFixed(2)
              }
            }
          })
          .catch((error) => {
            if (error.res) {
              this.$swal({
                icon: "error",
                title: "Error al modificar",
                text: "Error encontrado, verifique los datos o llame al administrador.",
              });
            } else {
              console.log("Error", error.message);
            }
          });
      } else {
        let array2 = {
          _id: item._id,
          destacado: false,
        };
        Api.put("productos/destacado", array2)
          .then((res) => {
            this.$swal.fire(
              "Producto excluido",
              "El producto se ha retirado de la lista de productos nuevos!",
              "info"
            );
            for (let i = 0; i < this.productos.length; i++) {
              if (this.productos[i]._id === res.data._id) {
                this.$set(this.productos, i, res.data);
                res.data.preciobsToF = parseFloat(res.data.preciobs);
                res.data.precioToF = parseFloat(res.data.precio);
                res.data.preciobsToF = res.data.preciobsToF.toFixed(2)
                res.data.precioToF = res.data.precioToF.toFixed(2)
              }
            }
          })
          .catch((error) => {
            if (error.res) {
              this.$swal({
                icon: "error",
                title: "Error al modificar",
                text:
                  "Error encontrado, verifique los datos o llame al administrador.",
              });
            } else {
              console.log("Error", error.message);
            }
          });
      }
    },
    verificacion() {
      for (
        let i = 0;
        i < this.$store.state.webamairca.permisos.length;
        i++
      ) {
        if (
          this.$store.state.webamairca.permisos[i].ruta === "Productos"
        ) {
          for (
            let j = 0;
            j < this.$store.state.webamairca.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.webamairca.permisos[i].accion[j] ===
              "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] ===
              "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    sinImg() {
      document.getElementById("prev").hidden = true;
      document.getElementById("next").hidden = false;
      this.dialog4 = true;
      this.imgsel = true;
      this.estatussel = "c";
      Api.get(
        "productos/sinseleccion?estatus=" + this.estatussel + "&img=" + true
      )
        .then((res) => {
          this.productos = [];
          this.listado = [];
          this.paginas = [];
          this.productos = res.data.resultado;
          if (this.productos.length > 0) {
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);
              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
          }
          this.tot = res.data.cantidad;
          this.disp = res.data.cantdi;
          this.nodisp = res.data.cantno;
          this.sines = res.data.cantnull;
          this.sinimg = res.data.cantimg;
          this.max = this.productos.length;
          if (this.max === 0) {
            this.min = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.min = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.min = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            this.$nextTick(() => {
              if (this.listado.length > 0 && document.getElementById("num1")) {
                document
                  .getElementById("num1")
                  .setAttribute(
                    "style",
                    "background-color:#adadad;border-radius:50%;"
                  );
              }
              if (document.getElementById("num2")) {
                document
                  .getElementById("num2")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
              if (document.getElementById("num3")) {
                document
                  .getElementById("num3")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
              if (document.getElementById("num4")) {
                document
                  .getElementById("num4")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
            });
            this.actual = 1;
            this.selpag = 1;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
    sinEst(item) {
      document.getElementById("prev").hidden = true;
      document.getElementById("next").hidden = false;
      this.dialog4 = true;
      this.estatussel = item;
      this.imgsel = false;
      Api.get("productos/sinseleccion?estatus=" + item + "&img=" + this.imgsel)
        .then((res) => {
          this.productos = [];
          this.listado = [];
          this.paginas = [];
          this.productos = res.data.resultado;
          if (this.productos.length > 0) {
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);
              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
          }
          this.tot = res.data.cantidad;
          this.disp = res.data.cantdi;
          this.nodisp = res.data.cantno;
          this.sines = res.data.cantnull;
          this.sinimg = res.data.cantimg;
          this.max = this.productos.length;
          if (this.max === 0) {
            this.min = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.min = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.min = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            this.$nextTick(() => {
              if (this.listado.length > 0 && document.getElementById("num1")) {
                document
                  .getElementById("num1")
                  .setAttribute(
                    "style",
                    "background-color:#adadad;border-radius:50%;"
                  );
              }
              if (document.getElementById("num2")) {
                document
                  .getElementById("num2")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
              if (document.getElementById("num3")) {
                document
                  .getElementById("num3")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
              if (document.getElementById("num4")) {
                document
                  .getElementById("num4")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
            });
            this.actual = 1;
            this.selpag = 1;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
    seleccion(item) {
      this.dialog4 = true;
      Api.get(
        "productos/pag?search=" +
          this.search5 +
          "&id=" +
          item +
          "&estatus=" +
          this.estatussel +
          "&img=" +
          this.imgsel
      )
        .then((res) => {
          this.productos = []
          this.dialog4 = false;
          this.max = res.data.max;
          this.min = this.max - res.data.resultado.length;
          this.productos = res.data.resultado;
          if (this.productos.length > 0) {
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);
              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
          }
          for (let i = 1; i <= res.data.paginas; i++) {
            this.paginas.push(i);
          }
          document
            .getElementById("num" + this.actual)
            .setAttribute(
              "style",
              "background-color:gainsboro;border-radius:50%;"
            );
          document.getElementById("next").hidden = false;
          document.getElementById("prev").hidden = false;
          if (this.min === 0) {
            document.getElementById("prev").hidden = true;
          }
          if (res.data.tope === true) {
            document.getElementById("next").hidden = true;
          }
          let a = item;
          this.listado = [];
          for (let i = 0; i < 4; i++) {
            if (a <= res.data.pag) {
              this.listado.push(a);
            }
            a++;
          }
          this.$nextTick(() => {
            this.actual = item;
            this.selpag = item;
            if (
              this.listado.length > 0 &&
              document.getElementById("num" + this.actual)
            ) {
              document
                .getElementById("num" + this.actual)
                .setAttribute(
                  "style",
                  "background-color:#adadad;border-radius:50%;"
                );
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
    prev() {
      let info = {
        estatus: this.seleccionado,
        max: this.min,
        ult: false,
        num: null,
      };
      let dat = this.actual - 1;
      if (dat < this.listado[0]) {
        info.ult = true;
        info.num = dat;
      }
      this.dialog4 = true;
      Api.post(
        "productos/prev?search=" +
          this.search5 +
          "&estatus=" +
          this.estatussel +
          "&img=" +
          this.imgsel,
        info
      )
        .then((res) => {
          if (res.data.resultado.length > 0) {
            this.productos = []
            this.max = res.data.max + 20;
            this.min = res.data.max;
            this.productos = res.data.resultado;
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);
              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            document.getElementById("next").hidden = false;
            if (res.data.tope === true) {
              document.getElementById("prev").hidden = true;
            }
          }
          if (info.ult) {
            let a = this.listado[0] - 5;
            this.listado = [];
            if (a < 0) {
              a = 0;
              document.getElementById("prev").hidden = true;
            }
            for (let i = 0; i < 4; i++) {
              a++;
              if (a <= res.data.pag) {
                this.listado.push(a);
              }
            }
            this.$nextTick(() => {
              this.actual = this.actual - 1;
              this.selpag = this.actual;
              if (
                this.listado.length > 0 &&
                document.getElementById("num" + this.actual)
              ) {
                document
                  .getElementById("num" + this.actual)
                  .setAttribute(
                    "style",
                    "background-color:#adadad;border-radius:50%;"
                  );
                if (document.getElementById("num" + (this.actual - 1))) {
                  document
                    .getElementById("num" + (this.actual - 1))
                    .setAttribute(
                      "style",
                      "background-color:gainsboro;border-radius:50%;"
                    );
                }
                if (document.getElementById("num" + (this.actual - 2))) {
                  document
                    .getElementById("num" + (this.actual - 2))
                    .setAttribute(
                      "style",
                      "background-color:gainsboro;border-radius:50%;"
                    );
                }
                if (document.getElementById("num" + (this.actual - 3))) {
                  document
                    .getElementById("num" + (this.actual - 3))
                    .setAttribute(
                      "style",
                      "background-color:gainsboro;border-radius:50%;"
                    );
                }
              }
            });
          } else {
            document
              .getElementById("num" + this.actual)
              .setAttribute(
                "style",
                "background-color:gainsboro;border-radius:50%;"
              );
            this.actual = this.actual - 1;
            this.selpag = this.actual;
            document
              .getElementById("num" + this.actual)
              .setAttribute(
                "style",
                "background-color:#adadad;border-radius:50%;"
              );
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          this.dialog4 = false;
          console.log(err);
        });
    },
    next() {
      let info = {
        estatus: this.seleccionado,
        max: this.max,
        ult: false,
        num: null,
      };
      let dat = this.actual + 1;
      if (dat > this.listado[this.listado.length - 1]) {
        info.ult = true;
        info.num = dat;
      }
      this.dialog4 = true;
      Api.post(
        "productos/next?search=" +
          this.search5 +
          "&estatus=" +
          this.estatussel +
          "&img=" +
          this.imgsel,
        info
      )
        .then((res) => {
          if (res.data.resultado.length > 0) {
            this.productos = []
            this.max = res.data.max;
            this.min = this.max - res.data.resultado.length;
            this.productos = res.data.resultado;
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);

              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            document.getElementById("prev").hidden = false;
            if (res.data.tope === true) {
              document.getElementById("next").hidden = true;
            }
          }
          if (info.ult) {
            let a = this.listado[this.listado.length - 1];
            this.listado = [];
            for (let i = 0; i < 4; i++) {
              a++;
              if (a <= res.data.pag) {
                this.listado.push(a);
              }
            }
            this.$nextTick(() => {
              this.actual = this.actual + 1;
              this.selpag = this.actual;
              if (
                this.listado.length > 0 &&
                document.getElementById("num" + this.actual)
              ) {
                document
                  .getElementById("num" + this.actual)
                  .setAttribute(
                    "style",
                    "background-color:#adadad;border-radius:50%;"
                  );
                if (document.getElementById("num" + (this.actual + 3))) {
                  document
                    .getElementById("num" + (this.actual + 3))
                    .setAttribute(
                      "style",
                      "background-color:gainsboro;border-radius:50%;"
                    );
                }
                if (document.getElementById("num" + (this.actual + 2))) {
                  document
                    .getElementById("num" + (this.actual + 2))
                    .setAttribute(
                      "style",
                      "background-color:gainsboro;border-radius:50%;"
                    );
                }
                if (document.getElementById("num" + (this.actual + 1))) {
                  document
                    .getElementById("num" + (this.actual + 1))
                    .setAttribute(
                      "style",
                      "background-color:gainsboro;border-radius:50%;"
                    );
                }
              }
            });
          } else {
            document
              .getElementById("num" + this.actual)
              .setAttribute(
                "style",
                "background-color:gainsboro;border-radius:50%;"
              );
            this.actual = this.actual + 1;
            this.selpag = this.actual;
            document
              .getElementById("num" + this.actual)
              .setAttribute(
                "style",
                "background-color:#adadad;border-radius:50%;"
              );
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          this.dialog4 = false;
          console.log(err);
        });
    },
    indice(indice, name) {
      this.form.imagen.splice(indice, 1);
      for (let i = 0; i < this.files.length; i++) {
        if (name === this.files[i].name) {
          this.files.splice(i, 1);
        }
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      this.files = [];
      this.form.imagen = [];
      Array.prototype.push.apply(this.files, e.target.files);
      const files = e.target.files;
      if (files !== undefined) {
        for (let i = 0; i < files.length; i++) {
          const fr = new FileReader();
          fr.readAsDataURL(files[i]);
          fr.addEventListener("load", () => {
            this.form.imagen.push({
              imageName: this.files[i].name,
              imageUrl: fr.result,
            });
          });
        }
      } else {
        this.form.imagen[0].imageName = "";
        this.form.imagen[0].imageFile = "";
        this.form.imagen[0].imageUrl = "";
      }
    },
    pickFile2() {
      this.$refs.pdf.click();
    },
    onFilePicked2(e) {
      this.form.pdf = {
        pdfName: "",
        pdfFile: "",
        pdfUrl: ""
      }
      const files = e.target.files;
      if (files !== undefined) {
          this.form.pdf.pdfName = files[0].name;
          if (this.form.pdf.pdfName.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", () => {
            this.form.pdf.pdfUrl = fr.result;
            this.form.pdf.pdfFile = files[0]; // this is an image file that can be sent to server...
          });
      } else {
        this.form.pdf.pdfName = "";
        this.form.pdf.pdfFile = "";
        this.form.pdf.pdfUrl = "";
      }
    },
    busqinit(item) {
      document.getElementById("prev").hidden = true;
      document.getElementById("next").hidden = false;
      Api.get(
        "productos/sinseleccion?search=" +
          item +
          "&estatus=" +
          this.estatussel +
          "&img=" +
          this.imgsel
      )
        .then((res) => {
          this.productos = [];
          this.listado = [];
          this.productos = res.data.resultado;
          if (this.productos.length > 0) {
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);
              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
          }
          this.tot = res.data.cantidad;
          this.disp = res.data.cantdi;
          this.nodisp = res.data.cantno;
          this.sines = res.data.cantnull;
          this.sinimg = res.data.cantimg;
          this.max = this.productos.length;
          if (this.max === 0) {
            this.min = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.min = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.min = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            this.$nextTick(() => {
              if (this.listado.length > 0 && document.getElementById("num1")) {
                document
                  .getElementById("num1")
                  .setAttribute(
                    "style",
                    "background-color:#adadad;border-radius:50%;"
                  );
              }
              if (document.getElementById("num2")) {
                document
                  .getElementById("num2")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
              if (document.getElementById("num3")) {
                document
                  .getElementById("num3")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
              if (document.getElementById("num4")) {
                document
                  .getElementById("num4")
                  .setAttribute(
                    "style",
                    "background-color:gainsboro;border-radius:50%;"
                  );
              }
            });
            this.actual = 1;
            this.selpag = 1;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
    cargarproductos() {
      this.estatussel = "c";
      this.imgsel = false;
      Api.get("productos/sinseleccion?estatus=c&img=" + this.imgsel)
        .then((res) => {
          this.productos = [];
          this.productos = res.data.resultado;
          if (this.productos.length > 0) {
            this.productos.map((data) => {
              data.preciobsToF = parseFloat(data.preciobs);
              data.precioToF = parseFloat(data.precio);
              data.preciobsToF = data.preciobsToF.toFixed(2)
              data.precioToF = data.precioToF.toFixed(2)
            });
          }
          this.tot = res.data.cantidad;
          this.disp = res.data.cantdi;
          this.nodisp = res.data.cantno;
          this.sines = res.data.cantnull;
          this.sinimg = res.data.cantimg;
          this.max = this.productos.length;
          if (this.max === 0) {
            this.min = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.min = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.min = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            this.$nextTick(() => {
              if (this.listado.length > 0 && document.getElementById("num1")) {
                document
                  .getElementById("num1")
                  .setAttribute(
                    "style",
                    "background-color:#adadad;border-radius:50%;"
                  );
              }
            });
            this.selpag = 1;
            this.actual = 1;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    abrir() {
      this.guard = false;
      this.dialog = true;
    },
    close() {
      this.form.imagen.imageName = "";
      this.form.imagen.imageFile = "";
      this.form.imagen.imageUrl = "";
      this.img2 = "";
      this.form.pdf = {
        pdfName: "",
        pdfFile: "",
        pdfUrl: ""
      }
      this.switch2 = false;
      this.sw2 = ""; 
      this.files = [];
      this.files2 = [];
      this.$refs.image.type = "text";
      this.$refs.image.type = "file";
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.editedIndex = -1;
    },
    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta operación!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Eliminar!",
        })
        .then((result) => {
          if (result.value) {
            Api.delete("productos/" + item._id)
              .then(() => {
                this.$swal.fire(
                  "Felicidades.!",
                  "Eliminación realizada exitosamente.",
                  "success"
                );
                this.initialize();
              })
              .catch((err) => {
                console.error(err);
              });
          }
        });
    },
    cargarestatus() {
      Api.get("productos/sinseleccion?estatus=c&img=" + this.imgsel)
        .then((res) => {
          this.tot = res.data.cantidad;
          this.disp = res.data.cantdi;
          this.nodisp = res.data.cantno;
          this.sines = res.data.cantnull;
          this.sinimg = res.data.cantimg;
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.productos.indexOf(item);
      Object.keys(this.form).map((key) => {
        if (item[key]) this.form[key] = item[key];
      });
      if (item.imagen && item.imagen.length > 0) {
        this.files2 = item.imagen;
      }
      if (item.categoria && item.categoria.nombre) {
        this.form.categoria = item.categoria._id;
      }
      if (item.pdf) {
        this.img2 = item.pdf;
      }
      if (item.estatus && item.estatus === "Disponible") {
        this.switch2 = true;
        this.sw2 = item.estatus;
      } else {
        this.switch2 = false;
        this.sw2 = item.estatus;
      }
      this.form.pdf = {
        pdfName: "",
        pdfFile: "",
        pdfUrl: ""
      }
      this.form._id = item._id;
      this.dialog = true;
    },
    save() {
      this.loading = true;
      this.guard = true;
      let array = {}
      if (this.editedIndex > -1) {
        this.form.estatus = this.sw2;
        if (this.files.length === 0) {
          this.form.imagen = this.files2;
        }
        if (!this.form.pdf.pdfFile) {
          this.form.pdf = this.img2;
        }
        if (this.form.categoria !== '') {
          array = {
            _id: this.form._id,
            categoria: this.form.categoria,
            co_art: this.form.co_art,
            estatus: this.form.estatus,
            existencia: this.form.existencia,
            imagen: this.form.imagen,
            nombre: this.form.nombre,
            precio: this.form.precio,
            preciobs: this.form.preciobs,
          }
        } else {
          array = {
            _id: this.form._id,
            co_art: this.form.co_art,
            estatus: this.form.estatus,
            existencia: this.form.existencia,
            imagen: this.form.imagen,
            nombre: this.form.nombre,
            precio: this.form.precio,
            preciobs: this.form.preciobs,
          }
        }
        const data = new FormData();
        Object.keys(array).map((key) => {
          if (Array.isArray(array[key])) {
            array[key].forEach((val) => {
              if (typeof val === "object" && val !== null) {
                return data.append(`${key}[]`, JSON.stringify(val));
              }
              return data.append(`${key}[]`, val);
            });
          } else if (
            typeof array[key] === "object" &&
            array[key] !== null
          ) {
            return data.append(key, JSON.stringify(array[key]));
          } else {
            return data.append(key, array[key]);
          }
        });
        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          let id = i == 0 ? "" : "-"+i
          data.append(this.form.co_art.trim()+id, file);
        } 
        if (this.form.pdf.pdfFile) {
          data.append(this.form.co_art.trim(), this.form.pdf.pdfFile);
        }
        Api.put("productos", data)
          .then((res) => {
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
            this.close();
            for (let i = 0; i < this.productos.length; i++) {
              if (this.productos[i]._id === res.data._id) {
                this.$set(this.productos, i, res.data);
                res.data.preciobsToF = parseFloat(res.data.preciobs);
                res.data.precioToF = parseFloat(res.data.precio);
                res.data.preciobsToF = res.data.preciobsToF.toFixed(2)
                res.data.precioToF = res.data.precioToF.toFixed(2)
              }
            }
            this.guard = false;
            this.cargarestatus();
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
            this.guard = false;
          });
      } else {
        console.log('en espera')
        // aun sin usar

        /* this.form.estatus = this.sw2;
        if (this.files.length === 0) {
          this.form.imagen = this.files2;
        }
        const data = new FormData();
        Object.keys(this.form).map((key) => {
          if (Array.isArray(this.form[key])) {
            this.form[key].forEach((val) => {
              if (typeof val === "object" && val !== null) {
                return data.append(`${key}[]`, JSON.stringify(val));
              }
              return data.append(`${key}[]`, val);
            });
          } else if (
            typeof this.form[key] === "object" &&
            this.form[key] !== null
          ) {
            return data.append(key, JSON.stringify(this.form[key]));
          } else {
            return data.append(key, this.form[key]);
          }
        });
        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          data.append("imagen", file);
        }
        Api.post("productos", data)
          .then((res) => {
            console.log(res.data);
            this.$swal.fire(
              "Felicidades.!",
              "Registro realizado exitosamente.",
              "success"
            );
            this.loading = false;
            this.guard = false;
            this.cargarproductos();
            this.close();
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
            this.guard = false;
          }); */
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/productos.scss";
</style>
